// extracted by mini-css-extract-plugin
export default {"thanks":"Thanks_thanks__siSO4"};